export * from "-!../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./rules-content.vue?vue&type=template&id=902d5b1a"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/settings/bonuses/rules-content.vue?vue&type=template&id=902d5b1a
// module id = Mo0m
// module chunks = 0